export interface SkillState {
  id: string;
  name?: string;
  description?: string;
}

export enum SkillStates {
  NOT_TESTED = 'SkillStateNode:1',
  NOT_PASSED = 'SkillStateNode:2',
  INFERRED = 'SkillStateNode:3',
  PASSED = 'SkillStateNode:4',
  NOT_INFERRED = 'SkillStateNode:5',
  DISCREPANCY = 'SkillStateNode:6',
}

export enum SkillSubStates {
  NOT_TESTED = 'SkillSubstateNode:1',
  NOT_PASSED_VIA_ASSESSMENT = 'SkillSubstateNode:2',
  INFERRED_VIA_DIAGNOSTIC = 'SkillSubstateNode:3',
  INFERRED_VIA_ASSESSMENT = 'SkillSubstateNode:4',
  PASSED_VIA_ASSESSMENT = 'SkillSubstateNode:5',
  PASSED_VIA_TEACHER = 'SkillSubstateNode:6',
  NOT_INFERRED_VIA_DIAGNOSTIC = 'SkillSubstateNode:7',
  DISCREPANCY_DIAGNOSTIC_ASSESSMENT = 'SkillSubstateNode:8',
  DISCREPANCY_ASSESSMENT_ASSESSMENT = 'SkillSubstateNode:9',
  DISCREPANCY_DIAGNOSTIC_DIAGNOSTIC = 'SkillSubstateNode:10',
  PASSED_VIA_EXITSLIP = 'SkillSubstateNode:11',
  INFERRED_VIA_EXITSLIP = 'SkillSubstateNode:12',
  DISCREPANCY_EXITSLIP_ASSESSMENT = 'SkillSubstateNode:13',
  DISCREPANCY_EXITSLIP_DIAGNOSTIC = 'SkillSubstateNode:14',
}

export enum SkillStatesLabel {
  PASSED = 'Passed',
  ALMOST_THERE = 'Almost There',
  KEEP_LEARNING = 'Keep Learning',
  NOT_STARTED = 'Not Started',
  REVIEW = 'Review',
  PLACED_OUT = 'Placed Out',
  DEMONSTRATED = 'Demonstrated',
}

export enum SkillStatesKey {
  PASSED = 'PASSED',
  ALMOST_THERE = 'ALMOST_THERE',
  KEEP_LEARNING = 'KEEP_LEARNING',
  NOT_STARTED = 'NOT_STARTED',
  REVIEW = 'REVIEW',
  PLACED_OUT = 'PLACED_OUT',
  DEMONSTRATED = 'DEMONSTRATED',
}

export enum SkillStatesClassname {
  ALMOST_THERE = 'c-almost-there',
  REVIEW = 'c-review',
  KEEP_LEARNING = 'c-keep-learning',
  NOT_STARTED = 'not-started',
  DEMONSTRATED = 'c-demonstrated',
}

export enum SkillStatesColor {
  PASSED__PERFECT__PLACED_OUT = '#008158',
  ALMOST_THERE = '#FFD349',
  KEEP_LEARNING = '#B71C1B',
  NOT_STARTED = '#9c9b9b',
  REVIEW = '#FDB814',
}
